import React, { useState } from 'react';
import './LoginForm.css';
import { observer } from 'mobx-react';
import { useStore } from '../../../../../../../Hooks/useStore';
import { Box, Image, Text } from "grommet";
import { FormView, Hide } from "grommet-icons";
import SameULoginModal from '../../../../../../../util/CheckMultiLogin/SameULoginModal';
import { Auth } from 'aws-amplify';
import usersService from '../../../IAM/Users/users.service';
import { CheckForMultiLogin } from '../../../../../../../util/CheckMultiLogin/CheckMultiLogin';
import { useUser } from '../../../../../context/User/UserContext';
import UserRestrictLoginModal from '../../../../../../../util/CheckMultiLogin/UserRestrictLoginModal';
import RoleChoose from '../../../../../../../util/CheckMultiLogin/RoleChoose';
import visible from '../../../../../../../assets/visible.png';
import hide from '../../../../../../../assets/hide.png';
import resend from '../../../../../../../assets/rotate_arrow.svg';
import VerificationInput from "react-verification-input";
import CommonButton from '../../../../common/Button/CommonButton';
import lock from "../../../../../../../assets/lock.gif"

const LoginForm = observer(() => {
    const { rootStore } = useStore();
    const {user, setUser} = useUser();

    const signin = async (username, password) => {
    
        if (!username) {
          rootStore.userStore.setLoginError("user","Please enter username");
          return;
        } else if (!password) {
          rootStore.userStore.setLoginError("password","Please enter password");
          return;
        } else {
          rootStore.userStore.setSignIn(true);
        }
    
        await Auth.signIn(username, password)
        .then(async (user) => {
          rootStore.userStore.setSignIn(false);
          console.log("custom signin",user);
          rootStore.userStore.setCognitoUser(user);
          if (user.challengeName == "NEW_PASSWORD_REQUIRED") {
            rootStore.userStore.setStep(4);
            return;
          }
          let userAttribute2 = await Auth.currentAuthenticatedUser();
          let isUserCLogin = false;
          if (userAttribute2) {
            let _username = userAttribute2.username;
            let userRoles = await usersService.getUserRoles(_username);
            if (userRoles.length) {
              userRoles.map((role) => {
                if (role.code == "Admin" || role.code == "SuperAdmin" || role.code == "EMS") {
                  if (role.code == "Admin") {
                    rootStore.userStore.handleRoleArr(role.code,"admin");
                  } else if (role.code == "EMS") {
                    rootStore.userStore.handleRoleArr(role.code, "ems");
                  } else {}
    
                  isUserCLogin = true;
                  if (role.code == "SuperAdmin") {          
                    rootStore.userStore.handleRoleArr(role.code,"admin");
                    if (userAttribute2.attributes['custom:isApprovedSuperAdmin']=="true") {
                      isUserCLogin = true;
                    } else {
                      isUserCLogin = false;
                    }
                  }
                }
              });
            }
    
            if (isUserCLogin) {
            } else {
              rootStore.userStore.handleUserRestModal(true);
            }
          }
          if (rootStore.userStore.getRoleArr.length == 1) {
            await StoreSession(userAttribute2, user, isUserCLogin, rootStore.userStore.getRoleArr[0].value, rootStore.userStore.getRoleArr[0].rolename);
          } else if (rootStore.userStore.getRoleArr.length > 1) {
            await showRoleChooseModal();
          }
           
        })
        .catch((error) => {
          rootStore.userStore.setSignIn(false);
          rootStore.userStore.setLoginError("api", error.message)
        })
      };
    
    
    
      const handleForgotPassword = (username) => {
        if (!username) {
          rootStore.userStore.setForgotPassUserError("Username field can not be empty");
          return;
        }
        rootStore.userStore.setSendCode(true);
        Auth.forgotPassword(username)
        .then((result) => {
          rootStore.userStore.setSendCode(false);
          console.log("forgot password click result", result);
          rootStore.userStore.setStep(3);
        })
        .catch((error) => {
          rootStore.userStore.setSendCode(false);
          rootStore.userStore.setForgotPassUserError("Username/client does not exist");
        })
      }
    
      const handleForgotPasswordSubmit = (code, newPassword, confirmPassword) => {
        if (!code || code.length < 6) {
          rootStore.userStore.setForgotPassSubmitError("code","Please enter varification code.")
          return;
        } else if (!newPassword) {
          rootStore.userStore.setForgotPassSubmitError("newPassword","Please enter your new password.")
          return;
        } else if (!confirmPassword) {
          rootStore.userStore.setForgotPassSubmitError("confirmPassword","Please enter confirm password.")
          return;
        } else if (newPassword !== confirmPassword) {
          rootStore.userStore.setForgotPassSubmitError("confirmPassword","Your password and confirm password not match.")
          return;
        } else {}
        rootStore.userStore.setSubmitCode(true);
        Auth.forgotPasswordSubmit(rootStore.userStore.getForgotPasswordUser, code, newPassword)
        .then((res) => {
          rootStore.userStore.setSubmitCode(false);
          console.log(res);
          rootStore.userStore.setStep(7);
        })
        .catch((error) => {
          console.log(error);
          if (error.code == "UnexpectedLambdaException" || error.code == "UserLambdaValidationException" || error.code.indexOf("Lambda") != -1) {
            // rootStore.userStore.setSuccessMsg("Password reset successfully.");
            rootStore.userStore.setStep(7)
            setTimeout(() => {
              // rootStore.userStore.setStep(1);
              rootStore.userStore.setSuccessMsg("");
            },2000);
          } else {
            rootStore.userStore.setForgotPassSubmitError("api",error.message);
          }
          rootStore.userStore.setSubmitCode(false);
        });
      }
    
      const handleChangePassword = async (username, oldpassword, newpassword) => {
        if (!rootStore.userStore.getNewUserPassword) {
          rootStore.userStore.setChangePassSubmitError("newPassword","Please enter your new password.");
          return;
        } else if (!rootStore.userStore.getNewUserConfirmPassword) {
          rootStore.userStore.setChangePassSubmitError("confirmPassword","Please enter your confirm password.");
          return;
        } else if (rootStore.userStore.getNewUserPassword !== rootStore.userStore.getNewUserConfirmPassword) {
          rootStore.userStore.setChangePassSubmitError("confirmPassword","Password and confirm password is not matched.");
          return;
        } else {
          rootStore.userStore.setChangePassSubmitError("","");
        }
        console.log(rootStore.userStore.getCognitoUser, oldpassword, newpassword);
        await Auth.completeNewPassword(rootStore.userStore.getCognitoUser,newpassword)
        .then(async (result) => {
    
          let userAttribute2 = await Auth.currentAuthenticatedUser();
          let isUserCLogin = false;
          if (userAttribute2) {
            let _username = userAttribute2.username;
            let userRoles = await usersService.getUserRoles(_username);
            if (userRoles.length) {
              userRoles.map((role) => {
                if (role.code == "Admin" || role.code == "SuperAdmin" || role.code == "EMS") {
                  if (role.code == "Admin") {
                    rootStore.userStore.handleRoleArr(role.code, "admin");
                  } else if (role.code == "EMS") {
                    rootStore.userStore.handleRoleArr(role.code, "ems");
                  } else {}
                  isUserCLogin = true;
                  if (role.code == "SuperAdmin") {
                    if (userAttribute2.attributes['custom:isApprovedSuperAdmin']=="true") { 
                      rootStore.userStore.handleRoleArr(role.code, "admin");
                      isUserCLogin = true;
                    } else {
                      isUserCLogin = false;
                    }
                  }
                }
              });
            }
            if (isUserCLogin) {}
            else {
              rootStore.userStore.handleUserRestModal(true);
            }
    
            if (rootStore.userStore.getRoleArr.length == 1) {
              await StoreSession(userAttribute2, rootStore.userStore.getCognitoUser, isUserCLogin, rootStore.userStore.getRoleArr[0].value, rootStore.userStore.getRoleArr[0].rolename);
            } else if (rootStore.userStore.getRoleArr.length > 1) {
              await showRoleChooseModal();
            }
          }
        })
        .catch((error) => {
          console.log("error",error);
          rootStore.userStore.setChangePassSubmitError("api",error.message);
        })
      }
    
      const handleSendEmailVerifyCode = async (email) => {
        if (!email) {
          rootStore.userStore.setEmailVerificationError("Please select email");
          return;
        }
        let code = await Auth.verifyCurrentUserAttribute('email');
        if (code === "SUCCESS") {
          rootStore.userStore.setStep(6);
        }
      }
    
      const generateStars = (starCount) => {
        // Ensure count is a positive integer
        starCount = Math.max(0, Math.floor(starCount));
        
        // Generate a string with specified number of star
        return "*".repeat(starCount);
      }
    
      const formatEmail = (email) => {
        // Split email into 2 parts from @
        let emailParts = email.split("@");
    
        // get first and last char
        let firstPart = emailParts[0];
        let firstChar = firstPart.charAt(0);
        let lastChar = firstPart.charAt(firstPart.length - 1);
    
        let starString = generateStars(firstPart.length - 2);
    
        // format email
        let formattedEmail = `${firstChar}${starString}${lastChar}@${emailParts[1]}`;
        return formattedEmail;
      }
    
      const SubmitVarificationCode = async (code) => {
        if (!code || code.length < 6) {
          rootStore.userStore.setEmailVarificationCodeError("code","Please enter verification code.");
          return;
        }
        let response = await Auth.verifyCurrentUserAttributeSubmit('email', code);
        if (response == "SUCCESS") {
          const session = await Auth.currentSession();
          console.log("session", session);
          const accessToken = session.getAccessToken().getJwtToken();
          console.log("accessToken", accessToken);
          rootStore.userStore.setSession(accessToken);
        }
      }
    
      const skipVarification = async () => {
        const session = await Auth.currentSession();
          console.log("session", session);
          const accessToken = session.getAccessToken().getJwtToken();
          console.log("accessToken", accessToken);
          rootStore.userStore.setSession(accessToken);
      }

      const showRoleChooseModal = async () => {
        rootStore.userStore.handleRoleSelectModal(true);
        if (rootStore.userStore.getURole !== "" ) {
          return rootStore.userStore.getURole;
        }
      }

    const StoreSession = async (userAttribute, user, isConfirmUser, role, roleLabel) => {
    console.log("user in StoreSession", user);
    userAttribute.attributes["custom:type"] = role;
    const userinformation = {
            username: userAttribute.username,
            ...userAttribute.attributes,
            roleLabel: roleLabel
        };
    setUser(userinformation);
    localStorage.setItem("userinfo", JSON.stringify(userinformation));

        if (user.challengeName != "NEW_PASSWORD_REQUIRED" || user.challengeName == undefined) {
        if (user.attributes) {
            rootStore.userStore.setUseremail(user.attributes.email);
        } else {
            if (user) {
            rootStore.userStore.setUseremail(user.challengeParam.userAttributes.email);
            }
        }
        let checkMultiLogin = await CheckForMultiLogin(user);
        if (checkMultiLogin && isConfirmUser==true) {
          rootStore.userStore.handleSameloginUserModal(true);
            return;
        } 
        
        let userAttribute = await Auth.currentAuthenticatedUser();
        if (!userAttribute.attributes.hasOwnProperty("email_verified")) {
            if (!userAttribute.attributes.email_verified) {
            rootStore.userStore.setStep(5);
            return;
            }
            return;
        }
        }
        setTimeout(async () => {
        const session = await Auth.currentSession();
        const accessToken = session.getAccessToken().getJwtToken();
        rootStore.userStore.setSession(accessToken);
        },2000);
};

    return (
        <Box className="container">
        {
          rootStore.userStore.getStep == 1
          ?
          (<div className="card">
            <h3>Log In</h3>
            <input 
              type="text"
              onChange={
                (e) => {
                  rootStore.userStore.setUsername(e.target.value);
                  rootStore.userStore.resetLoginError();
                }
              }
              value={rootStore.userStore.getUsername}
              placeholder="User Id" 
              className={rootStore.userStore.getLoginError.input == "user" || rootStore.userStore.getLoginError.input == "api" ? "errorInput userInput" : "userInput"} 
            />
            <Box className="passwordMain">
              <input 
                type={rootStore.userStore.getPassVisibility ? "text" : "password"} 
                onChange={
                  (e) => {
                    rootStore.userStore.resetLoginError();
                    rootStore.userStore.setPassword(e.target.value);
                  }
                }
                value={rootStore.userStore.getPassword}
                placeholder="Password"
                className={rootStore.userStore.getLoginError.input == "password" || rootStore.userStore.getLoginError.input == "api" ? "errorInput pwdInput" : "pwdInput"}
              />
              <Box className="signUpVisibilityIcon">
              {
                rootStore.userStore.getPassVisibility
                  ?
                <Text  onClick={() => rootStore.userStore.setPasswordVisiblity(false)}><img src={hide} /></Text>
                  :
                <Text onClick={() => rootStore.userStore.setPasswordVisiblity(true)}><img src={visible} /></Text>
              }
              </Box>
            </Box>
            {
              rootStore.userStore.getLoginError.message
              &&
              <Text className="errorMessage">**{rootStore.userStore.getLoginError.message}**</Text>
            }

            <Box className='frt-txt'>
              <Text className="forgotpwd">Forgot your password ? <Text className='link-txt' onClick={() => rootStore.userStore.setStep(2)}> We’ve got you!</Text></Text>
            </Box>
            <button onClick={() => signin(rootStore.userStore.getUsername,rootStore.userStore.getPassword)} style={{backgroundColor: rootStore.userStore.getSignIn ? "rgb(137, 204, 217)" : "#357EFF", cursor:"pointer"}} disabled={rootStore.userStore.getSignIn} className="actionBtn">Let’s Go</button>
          </div>)
          : rootStore.userStore.getStep == 2
          ?
          (<div className="card">
            <h4 className="title">Reset Your Password</h4>
            <input 
              type="text" 
              onChange={
                (e) => {
                  rootStore.userStore.setForgotPassUserError("");
                  rootStore.userStore.setForgotPasswordUser(e.target.value);
                }
              }
              value={rootStore.userStore.getForgotPasswordUser}
              placeholder="User Id" 
              style={{marginBottom: 0}}
              className={rootStore.userStore.getForgotPassUserError !== "" ? "errorInput" : "userInput"}
            />
            {
              rootStore.userStore.getForgotPassUserError 
              &&
              <Text className="errorMessage">**{rootStore.userStore.getForgotPassUserError}**</Text>
            }
            
            <button onClick={() => handleForgotPassword(rootStore.userStore.getForgotPasswordUser)} disabled={rootStore.userStore.getSendCode} style={{backgroundColor: rootStore.userStore.getSendCode ? "rgb(137, 204, 217)" : "#357EFF",marginTop: 40, cursor:"pointer"}} className="actionBtn">Send Code</button>
            <Box style={{textAlign: 'center'}}>
              <button onClick={() => rootStore.userStore.setStep(1)} disabled={rootStore.userStore.getSendCode} style={{color: rootStore.userStore.getSendCode ? "rgb(137, 204, 217)" : "#357EFF", border:"none", cursor:"pointer"}} className="actionTxt">Back</button>
            </Box>
          </div>)
          : rootStore.userStore.getStep == 3
           ?
          (<div className="card">
            <h4 className="title">Reset Your Password</h4>
            <label className='vfy-label'>Verification Code</label>
            <VerificationInput 
              classNames={{
                container: "verify-input-container",
                character: rootStore.userStore.getForgotPassSubmitError.input == "code" ? "verify-input-error verify-input-character" : "verify-input-character",
                characterInactive: "character--inactive",
                characterSelected: "character--selected",
                characterFilled: "character--filled",
              }}
              onChange={(value) => {
                rootStore.userStore.setVarificationCode(value);
              }}
              validChars="0-9"
              placeholder=""
            />
            <Box className="passwordMain mt-20">
              <input 
                type={rootStore.userStore.getNewPasswordVisibility ? "text" : "password"} 
                onChange={
                  (e) => {
                    rootStore.userStore.setNewPassword(e.target.value);
                    rootStore.userStore.resetForgotPassSubmitError();
                  }
                }
                value={rootStore.userStore.getNewPassword}
                placeholder="New Password" 
                className={rootStore.userStore.getForgotPassSubmitError.input == "newPassword" || rootStore.userStore.getForgotPassSubmitError.input == "api" ? "errorInput pwdInput" : "pwdInput"}
              />
              <Box className="signUpVisibilityIcon">
                {
                  rootStore.userStore.getNewPasswordVisibility
                    ?
                  <Text onClick={() => rootStore.userStore.setNewPasswordVisibility(false)}><img src={hide} /></Text>
                    :
                  <Text onClick={() => rootStore.userStore.setNewPasswordVisibility(true)}><img src={visible} /></Text>
                }
              </Box>
            </Box>

            <Box className="passwordMain mt-20">
              <input 
                type={rootStore.userStore.getConfirmPasswordVisibility ? "text" : "password"} 
                onChange={
                  (e) => {
                    rootStore.userStore.setConfirmPassword(e.target.value);
                    rootStore.userStore.resetForgotPassSubmitError();
                  }
                }
                value={rootStore.userStore.getConfirmPassword}
                placeholder="Confirm New Password" 
                className={rootStore.userStore.getForgotPassSubmitError.input == "confirmPassword" || rootStore.userStore.getForgotPassSubmitError.input == "api" ? "errorInput pwdInput" : "pwdInput"}
              />
              <Box className="signUpVisibilityIcon">
                {
                 rootStore.userStore.getConfirmPasswordVisibility
                    ?
                  <Text onClick={() => rootStore.userStore.setConfirmPasswordVisibility(false)}><img src={hide} /></Text>
                    :
                  <Text onClick={() => rootStore.userStore.setConfirmPasswordVisibility(true)}><img src={visible} /></Text>
                }
              </Box>
            </Box>
            {
              rootStore.userStore.getForgotPassSubmitError.message 
              &&
              <Text className="errorMessage">**{rootStore.userStore.getForgotPassSubmitError.message}**</Text>
            }
            {
              rootStore.userStore.getSuccessMsg 
              &&
              <Text className="successMessage">{rootStore.userStore.getSuccessMsg}</Text>
            }
            <div style={{ 
              marginTop: '16px',
              padding: '12px',
              backgroundColor: '#f8f9fa',
              borderRadius: '4px',
              fontSize: '12px',
              color: '#555',
              width: '100%'
            }}>
              <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Password minimum length</div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                <span style={{marginLeft: '4px' }}>8 character(s)</span>
              </div>
              <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Password requirements</div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                <span>• Contains at least 1 lowercase letter</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                <span>• Contains at least 1 uppercase letter</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                <span>• Contains at least 1 special character</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span>• Contains at least 1 number</span>
              </div>
            </div>
            <button onClick={() => handleForgotPasswordSubmit(rootStore.userStore.getVarificationCode, rootStore.userStore.getNewPassword, rootStore.userStore.getConfirmPassword)} disabled={rootStore.userStore.getSubmitCode} style={{backgroundColor: rootStore.userStore.getSubmitCode ? "rgb(137, 204, 217)" : "#357EFF",marginTop: 40}} className="actionBtn">Submit</button>
            <Box style={{textAlign: 'center'}}>
              <button onClick={() => handleForgotPassword(rootStore.userStore.getForgotPasswordUser)} disabled={rootStore.userStore.getSubmitCode} style={{color: rootStore.userStore.getSubmitCode ? "rgb(137, 204, 217)" : "#357EFF"}} className="actionTxt"><img src={resend} /> Resend Code</button>
            </Box>
          </div>)
          : rootStore.userStore.getStep == 4
          ? 
          (<div className="card">
            <h4 className="title">Change Your Password</h4>
            <Box className="passwordMain mt-20">
              <input 
                type={rootStore.userStore.getNewUserPasswordVisibility ? "text" : "password"} 
                onChange={
                  (e) => {
                    rootStore.userStore.setNewUserPassword(e.target.value);
                    rootStore.userStore.resetChangePassSubmitError();
                  }
                }
                value={rootStore.userStore.getNewUserPassword}
                placeholder="New Password"
                className={rootStore.userStore.getChangePassSubmitError.input == "newPassword" || rootStore.userStore.getChangePassSubmitError.input == "api" ? "errorInput pwdInput" : "pwdInput"} 
              />
              <Box className="signUpVisibilityIcon">
                {
                  rootStore.userStore.getNewUserPasswordVisibility
                  ?
                  <Text onClick={() => rootStore.userStore.setNewUserPasswordVisibility(false)}><img src={hide} /></Text>
                  :
                  <Text onClick={() => rootStore.userStore.setNewUserPasswordVisibility(true)}><img src={visible} /></Text>
                }
              </Box>
            </Box>

            <Box className="passwordMain mt-20">
              <input 
                type={rootStore.userStore.getNewUserConfirmPasswordVisibility ? "text" : "password"} 
                onChange={
                  (e) => {
                    rootStore.userStore.setNewUserConfirmPassword(e.target.value);
                    rootStore.userStore.resetChangePassSubmitError();
                  }
                }
                value={rootStore.userStore.getNewUserConfirmPassword}
                placeholder="Confirm Password" 
                className={rootStore.userStore.getChangePassSubmitError.input == "confirmPassword" || rootStore.userStore.getChangePassSubmitError.input == "api" ? "errorInput pwdInput" : "pwdInput"}
              />
              <Box className="signUpVisibilityIcon">
                {
                  rootStore.userStore.getNewUserConfirmPasswordVisibility
                  ?
                  <Text onClick={() => rootStore.userStore.setNewUserConfirmPasswordVisibility(false)}><img src={hide} /></Text>
                  :
                  <Text onClick={() => rootStore.userStore.setNewUserConfirmPasswordVisibility(true)}><img src={visible} /></Text>
                }
              </Box>
              
            </Box>
            {
              rootStore.userStore.getChangePassSubmitError.message
              &&
              <Text className="errorMessage">**{rootStore.userStore.getChangePassSubmitError.message}**</Text>
              }
              {
              rootStore.userStore.getChangePasswordSuccessMsg 
              &&
              <Text className="successMessage">{rootStore.userStore.getChangePasswordSuccessMsg}</Text>
            }
            <div style={{ 
              marginTop: '16px',
              padding: '12px',
              backgroundColor: '#f8f9fa',
              borderRadius: '4px',
              fontSize: '12px',
              color: '#555',
              width: '100%'
            }}>
              <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Password minimum length</div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                <span style={{marginLeft: '4px' }}>8 character(s)</span>
              </div>
              <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Password requirements</div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                <span>• Contains at least 1 lowercase letter</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                <span>• Contains at least 1 uppercase letter</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                <span>• Contains at least 1 special character</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span>• Contains at least 1 number</span>
              </div>
            </div>
            <button onClick={() => handleChangePassword(rootStore.userStore.getUsername,rootStore.userStore.getPassword,rootStore.userStore.getNewUserPassword)} disabled={rootStore.userStore.getChangePassword} style={{backgroundColor: rootStore.userStore.getChangePassword ? "rgb(137, 204, 217)" : "#357EFF"}} className="actionBtn">Change Password</button>
          </div>)
          : rootStore.userStore.getStep == 5
          ?
          (
            <div className="card">
              <h4 className="title accountRecoveryTitle">Account recovery requires verified contact information</h4>
              <Box className="emailRadio">
                <input
                type="radio"
                id="email_verify"
                onChange={(e) => rootStore.userStore.setSelectedEmail(e.target.value)}
                value={rootStore.userStore.getUseremail}
                />
                <label for="email_verify" className="emailText">Email: {formatEmail(rootStore.userStore.getUseremail)}</label>
              </Box>
              {
              rootStore.userStore.getEmailVerificationError 
              &&
              <Text className="errorMessage">**{rootStore.userStore.getEmailVerificationError}**</Text>
              }
              <button onClick={() => handleSendEmailVerifyCode(rootStore.userStore.getSelectedEmail)} disabled={rootStore.userStore.getChangePassword} style={{backgroundColor: rootStore.userStore.getChangePassword ? "rgb(137, 204, 217)" : "#357EFF",marginTop: 40}} className="actionBtn">Verify</button>
              <Box style={{textAlign: 'center', display: 'flex', alignItems: "center"}}>
                <button disabled={rootStore.userStore.getSignIn} style={{width: "100%", color: rootStore.userStore.getSignIn ? "rgb(137, 204, 217)" : "#357EFF", paddingLeft: 10,paddingRight: 10}} onClick={() => skipVarification()} className="actionTxt">Skip</button>
              </Box>
            </div>
          )
          : rootStore.userStore.getStep == 6
          ?
          (
            <div className="card">
              <h4 className="title accountRecoveryTitle">Account recovery requires verified contact information</h4>
              {/* <input
                className="userInput w-100"
                type="number"
                placeholder="Verification code"
                onChange={(e) => rootStore.userStore.setVerificationCode(e.target.value)}
                value={rootStore.userStore.getVerificationCode}
                /> */}
              <VerificationInput 
                classNames={{
                  container: "verify-input-container",
                  character: rootStore.userStore.getEmailVarificationCodeError.input == "code" ? "verify-input-error verify-input-character" : "verify-input-character",
                  characterInactive: "character--inactive",
                  characterSelected: "character--selected",
                  characterFilled: "character--filled",
                }}
                onChange={(value) => {
                  rootStore.userStore.setVerificationCode(value);
                  rootStore.userStore.resetEmailVarificationCodeError();
                }}
                validChars="0-9"
                placeholder=""
              />
              {
              rootStore.userStore.getEmailVarificationCodeError.message 
              &&
              <Text className="errorMessage">**{rootStore.userStore.getEmailVarificationCodeError.message}**</Text>
              }
              <button onClick={() => SubmitVarificationCode(rootStore.userStore.getVerificationCode)} disabled={rootStore.userStore.getChangePassword} style={{marginTop: 0,backgroundColor: rootStore.userStore.getChangePassword ? "rgb(137, 204, 217)" : "#357EFF",marginTop: 40}} className="actionBtn">Submit</button>
              <Box style={{textAlign: 'center', display: 'flex', alignItems: "center"}}>
                <button disabled={rootStore.userStore.getSignIn} style={{width: "100%", color: rootStore.userStore.getSignIn ? "rgb(137, 204, 217)" : "#357EFF", paddingLeft: 10,paddingRight: 10}} onClick={() => skipVarification()} className="actionTxt">Skip</button>
              </Box>
            </div>
          )
          :rootStore.userStore.getStep === 7
          ?
          (
              <Box className="container" style={{position:"relative"}}>
              <Box style={{textAlign: 'center', display: 'flex', alignItems: "center", width:"340px",height:"296px",backgroundColor:"white",borderRadius:"10px",position:'relative',}}>
              <div style={{marginTop:"40px"}}>
                <Box style={{
                  width:"148px",
                  height:"134px",
                  gap:"10px",
                  display:"flex",
                  alignItems:'center'
                }}>
                  <Image src={lock}
                    alt="Camera svg"
                    style={{ width:'80px',height:'80px'}}
                  />
                  <Text className='vfy-label' style={{fontSize:"16px",lineHeight:"22px",fontWeight:'600',color:"#4B628A"}} >Password changed successfully!</Text>
                </Box>
              </div>
                <div style={{position:"absolute",bottom:'40px'}}>
                <CommonButton
                  title="Back to Log In"
                  padding="14px 49px 14px 49px"
                  color="#fff"
                  bgColor="#357EFF"
                  radius={10}
                  border="1px solid #357EFF"
                  lineheight="14px"
                  ml={5}
                  gap={10}
                  width="220px"
                  height="52px"
                  onclick={() => rootStore.userStore.setStep(1)}
              />
                </div>
              </Box>
        </Box>
          )
          :
          null
        }
        {
          rootStore.userStore.getSameloginUserModal &&
          <SameULoginModal />
        }
        {
          rootStore.userStore.getRoleSelectModal && 
          <RoleChoose storeSession={StoreSession}/>
        }
        {
          rootStore.userStore.getUserRestModal && 
          <UserRestrictLoginModal />
        }
        {
          rootStore.userStore.getMultiLogin &&
          <SameULoginModal />
        }
      </Box>
    );
});

export default LoginForm;
